<script>
import { onMounted, ref, watch } from 'vue';

export default {
  props: {
    buckets: {
      type: Object,
      required: true,
    },
    points: {
      type: Object,
      required: true,
    },
    selectedMinPrice: {
      type: Number,
      default: null,
    },
    selectedMaxPrice: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const pricesArray = ref([]);

    function extractPricesArray(pricesObject, pointsObject) {
      if (!pricesObject) {
        return [];
      }
      const pointsObjectIterator = structuredClone(pointsObject);
      const pricesObjectIterator = Object.keys(pricesObject).sort((a, b) => (parseInt(a) - parseInt(b)));
      //console.log('pricesObjectIterator', pricesObjectIterator);

      //console.log('pricesObject', pricesObject);
      //console.log('pointsObject', pointsObject);

      let maxPoints = 22;
      let n_points_remaining = pointsObject.length;
      const istogramPrices = [];

      while (pointsObjectIterator.length){
        const n_points_to_merge = Math.ceil(n_points_remaining / maxPoints);
        let price = null;
        const maxPrice = pointsObjectIterator[pointsObjectIterator.length - 1];
        let count = 0;

        for (let i = 0; i < n_points_to_merge; i ++){
          price = pointsObjectIterator.pop();
          /*if (!pricesObject[pricePoint]) continue;
          count += pricesObject[pricePoint].value;*/
        }

        if (pricesObjectIterator.length) while (pricesObjectIterator[pricesObjectIterator.length - 1] >= price) {
          count += pricesObject[pricesObjectIterator.pop()].value;
          if (!pricesObjectIterator.length) break;
        }

        // TODO can be improved further
        istogramPrices.push({
          minPrice: parseInt(price, 10),
          maxPrice: parseInt(maxPrice, 10),
          count: parseInt(count, 10),
        });
        n_points_remaining -= n_points_to_merge;
        maxPoints--;
      }
      
      istogramPrices.reverse();

      /*for (const point of pointsObject) {
        if (element > props.min) break;
        firstPoint = element;
      }*/

      //console.log('istogramPrices', istogramPrices);
      return istogramPrices;

      /*return Object.entries(pricesObject).map(([price, item]) => ({
        price: parseInt(price, 10),
        count: parseInt(item.value, 10),
      }));*/
    }

    function getBarHeight(count) {
      const maxCount = Math.max(...pricesArray.value.map((item) => item.count)) + 1;
      return ((count + 1) / maxCount) * 100;
    }

    function isInRange(minPrice, maxPrice) {
      return minPrice >= props.selectedMinPrice && maxPrice <= props.selectedMaxPrice;
    }

    function updateChartData() {
      if (props.buckets) {
        pricesArray.value = extractPricesArray(props.buckets, props.points);
      } else {
        pricesArray.value = [];
      }
    }

    onMounted(() => {
      updateChartData();
    });

    watch(
      () => props.buckets,
      () => {
        updateChartData();
      },
      { deep: true },
    );

    return {
      pricesArray,
      getBarHeight,
      isInRange,
    };
  },
};
</script>

<template>
  <div class="w-full h-24 rounded-top overflow-hidden">
    <div
      v-if="pricesArray.length && pricesArray.length > 4"
      class="flex justify-around items-end h-full pt-1 border-b-2 space-x-[0.15rem]"
    >
      <div
        v-for="item in pricesArray"
        :key="item.price"
        class="flex-grow w-10 max-w-[20px] transition-all duration-300 ease-in-out rounded-t-sm bg-gray-300"
        style="width: 15px; color: transparent"
        :style="{ height: `${getBarHeight(item.count)}%`, backgroundColor: isInRange(item.minPrice, item.maxPrice) ? 'rgb(0, 143, 198)' : 'rgb(209, 213, 219)'}"
      >
        .
      </div>
    </div>
    <div v-else class="flex justify-center items-center h-full text-sm text-gray-600"></div>
  </div>
</template>

<style scoped></style>
